<template>
  <div class="pageContent" style="overflow:hidden" v-bind:style="{ height: winHeight + 'px' }">
    <mu-appbar>
      <mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback"/>
      <span style="margin-left:-0.6rem" class="topT">地图选房</span>
    </mu-appbar>
    <div class="main2">
      <div class="building_floor">
        <!--楼栋开始-->
        <div class="building" style="display: block;overflow:hidden">
          <a
            class="building_title_down"
            v-bind:class="{ 'building_title': buildOpen }"
            v-on:click="buildOpen = !buildOpen"
            href="javascript:void(0)"
            id="hall_title"
          >
            <div class="num_title">{{currentBuild.HallName}}</div>
            <div class="rooms_title">{{currentBuild.roomNum}}间</div>
            <div class="clear"></div>
          </a>
          <ul
            v-bind:style="{ height: buildOpen?buildHeight:'0px'}"
            id="hall_bar"
            class="building_all"
            style="display: block;overflow:hidden"
          >
            <li
              v-on:click="chooseBuildClick(bIndex)"
              v-bind:class="{ select: currentBuild.HallName == build.HallName }"
              v-for="(build,bIndex) in useableBuilds"
            >
              <a href="javascript:void(0)">
                <div class="building_num">{{build.HallName}}</div>
                <div class="building_rooms">{{build.roomNum}}间</div>
                <div class="clear"></div>
              </a>
            </li>
          </ul>
        </div>
        <!--楼层开始-->
        <div class="floor" style="display:block;">
          <a
            id="floor_title"
            v-bind:class="{ 'floor_title': floorOpen }"
            v-on:click="floorOpen = !floorOpen"
            href="javascript:void(0)"
            class="floor_title_down"
          >
            <div class="num_title">{{currentFloor.FloorName}}</div>
            <div class="rooms_title">{{currentFloor.roomNum}}间</div>
            <div class="clear"></div>
          </a>
          <transition name="list-fade">
            <ul
              id="floor_bar"
              v-bind:style="{ 'max-height': floorOpen?'5rem':'0px'}"
              class="floor_all"
            >
              <li
                v-on:click="chooseFloorClick(fIndex)"
                v-bind:class="{ select: currentFloor.FloorName == floor.FloorName }"
                v-for="(floor,fIndex) in currentBuild.Floors"
              >
                <a href="javascript:void(0)">
                  <div class="floor_num">{{floor.FloorName}}</div>
                  <div class="floor_rooms">{{floor.Rooms.length}}间</div>
                  <div class="clear"></div>
                </a>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
    <div
      id="map"
      style="width:7.5rem;position:relative;top:0px;"
      v-bind:style="{ height: mapHeight + 'px' }"
    ></div>
    <div class="clear"></div>
    <div class="room">
      <transition name="slide-fade">
        <div v-if="showRoomTraits" id="chamber_traits" class="feature" @close="closeRoomTraits">
          <table>
            <tbody>
              <tr>
                <td width="110" valign="top">
                  <strong>{{displayRoom.ChamberNumber}}&nbsp;房间特征:</strong>
                </td>
                <td>
                  <span>{{displayRoom.Hobby}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </transition>
      <div class="roomlist">
        <ul id="assign_bar" style="list-style-type:none;" class="rooming">
          <li v-if="selectedRooms.length==0" class="waiting">待选</li>
          <li v-if="selectedRooms.length>0" class v-for="(room,rIndex) in selectedRooms">
            <a
              href="javascript:void(0)"
              v-on:click="setDisplayRoom(rIndex)"
              class="room_num"
            >{{room.ChamberNumber}}</a>
            <a href="javascript:void(0)" v-on:click="cancelRoomClick(rIndex)" class="close_num">X</a>
          </li>
        </ul>
        <div class="submit">
          <input
            v-on:click="postRoom"
            id="btnSaveAssignRooms"
            value
            class="submitBtn"
            style="display: inline;"
            type="button"
          >
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline"/>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/theme.less";
.main2 {
  position: fixed;
  top: 62px;
  left: 0;
  z-index: 300;
  width: 60px;
}
.building,
.floor {
  float: left;
  margin-left: 5px;
}
a.building_title_down,
a.floor_title_down {
  background: url(../../../static/self-helpSelectRoom/title_down.png);
  background-size: 46px 49px;
  width: 46px;
  height: 49px;
  display: block;
  color: #315012;
}
a.building_title,
a.floor_title {
  background: url(../../../static/self-helpSelectRoom/title_up.png);
  background-size: 46px 49px;
  width: 46px;
  height: 49px;
  display: block;
  color: #315012;
  position: relative;
  z-index: 100;
}
a.building_title:active,
a.floor_title:active {
  color: #eeeeee;
}
.building_title a:active,
.floor_title a:active {
  background: url(/images/AssignRoom/floor_hover.png);
  background-size: 46px 49px;
  width: 46px;
  height: 49px;
}
ul.building_all {
  margin-top: -1px;
  background-color: white;
  opacity: 0.75;
  width: 46px;
  border-radius: 6px;
  border: solid 5px #62a21d;
  box-shadow: 0 2px 1px #7f7f7f;
  padding: 0;
  display: block;
  z-index: -100;
  -webkit-transition: 0.6s;
  -moz-transition: 0.6s;
  -o-transition: 0.6s;
  transition: 0.6s;
}
ul.floor_all {
  margin-top: -1px;
  background-color: white;
  opacity: 0.75;
  width: 46px;
  border-radius: 6px;
  border: solid 5px #62a21d;
  box-shadow: 0 2px 1px #7f7f7f;
  padding: 0;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: -100;
  -webkit-transition: 0.6s;
  -moz-transition: 0.6s;
  -o-transition: 0.6s;
  transition: 0.6s;
}
ul.floor_all::-webkit-scrollbar {
  display: none;
}
ul.building_all li,
ul.floor_all li {
  height: 48px;
  border-bottom: dashed 1px #88b753;
  display: block;
  width: 36px;
}
ul.building_all li a,
ul.floor_all li a {
  color: #315012;
  display: block;
  height: 48px;
}
ul.building_all li a:active,
ul.floor_all li a:active {
  color: #88b753;
  display: block;
}
ul.building_all li:last,
ul.floor_all li:last {
  border-bottom: none;
}
ul.building_all li.select,
ul.floor_all li.select {
  background: rgba(106, 157, 48, 0.3);
}
.building_num,
.floor_num {
  font-weight: 700;
  text-align: center;
  font-size: 13px;
  padding-top: 7px;
}
.building_rooms,
.floor_rooms {
  font-size: 12px;
  text-align: center;
}
.num_title {
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  padding-top: 5px;
}
.rooms_title {
  font-size: 12px;
  text-align: center;
}
.noRoom {
  color: #999999;
}
.clear {
  clear: both;
}
.select {
  margin-top: 0;
}
/*底部房间*/
.room {
  position: fixed;
  bottom: 0px;
  left: 0;
  z-index: 600;
  width: 100%;
}
.roomlist {
  background: rgba(106, 157, 48, 0.3);
  padding-bottom: 10px;
}
.roomlist2 {
  background: rgba(106, 157, 48, 0.3);
  padding-bottom: 10px;
  position: fixed;
  left: 0;
  top: 52px;
  z-index: 600;
  width: 100%;
}
ul.rooming {
  float: left;
  margin: 0 0 0 1%;
  padding: 0;
  width: 75%;
}
ul.rooming li {
  border: solid 2px #71ab29;
  color: #315012;
  float: left;
  font-size: 14px;
  padding: 0;
  width: 30%;
  margin: 10px 0 0 1%;
  text-align: center;
  background-color: white;
  font-weight: 700;
  height: 40px;
  vertical-align: middle;
}

a.room_num {
  float: left;
  vertical-align: middle;
  padding: 10px 0 10px 0;
  color: #315012;
  display: block;
  width: 34px;
  height: 20px;
  width: 60%;
}
a.close_num {
  width: 40%;
  color: #315012;
  float: right;
  background: rgba(106, 157, 48, 0.3);
  margin: 0;
  height: 100%;
  padding: 10px 0;
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif;
}
a.close_num:active {
  color: white;
}
ul.rooming li.waiting {
  padding: 10px 0;
  height: 40px;
  color: #93a582;
}
.submit {
  float: right;
  margin: 10px 2% 0 0;
  width: 20%;
}
.submitBtn {
  background: url(../../../static/self-helpSelectRoom/choose_btn.png);
  background-size: 55px 43px;
  width: 55px;
  height: 43px;
  display: none;
  border: none;
  float: right;
}
.submitBtn:active {
  //background: url(../../../static/self-helpSelectRoom/choose_btn_hover.png);
  background-size: 55px 43px;
  width: 55px;
  height: 43px;
  display: block;
}
/*底部房间特征*/
.feature {
  background-color: white;
  opacity: 0.75;
  border-radius: 6px;
  border: solid 3px #62a21d;
  margin-bottom: 2px;
  color: #315012;
  padding: 0 0 0 10px;
  font-size: 14px;
  line-height: 18px;
  height: auto;
}
.feature table {
  width: 100%;
  overflow-x: scroll;
  display: block;
}
.feature strong {
  font-weight: 700;
}
.feature span {
  padding: 0 0 0 5px;
}
/*淡入淡出 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<script>
import api from "../../api";
import map from "../../components/map.js";
import { googleMap } from "../../components/googleMap.js";
import { mapMutations, mapGetters } from "vuex";
import mapData from "./mapData.js";
window.onload = map.loadGoogle;
export default {
  data() {
    return {
      //谷歌地图
      gmaps: "",
      //当前地图
      map: "",
      // 接口数据
      apiData: "",
      // 建筑->楼层->可用房间
      useableBuilds: "",
      // 选中房间
      selectedRooms: [],
      // 房间特性
      Traits: [],
      // 当前建筑(当前图片展示建筑)
      currentBuild: "",
      // 当前楼层(当前图片展示楼层)
      currentFloor: "",
      //区分优选房
      divisionGoodRoom: true,
      //窗口高度
      winHeight: 0,
      //地图高度
      mapHeight: 0,
      //选中并展示房间特征的房间
      displayRoom: "",
      //是否展示房间特征
      showRoomTraits: false,
      //楼栋是否伸开
      buildOpen: true,
      //楼层是否伸开
      floorOpen: true,
      //提示信息
      hintMsg: "",
      //提示框显示状态
      toast: false,
      params: "",
      //订单号
      resv: "",
      //用户账号
      cardNo: "",
      sign: ""
    };
  },
  activated() {
    this.params = new this.URLSearchParam();
    //解析url参数
    var query = this.$route.query;
    if (typeof query.resv != "undefined") {
      this.params.append("resv", query.resv);
      this.params.append("hotelcode", query.hotelcode);
      this.params.append("cardNo", query.cardNo);
      this.params.append("sign", query.sign);
      this.resv = query.resv;
      this.cardNo = query.cardNo;
      this.sign = query.sign;
    } else {
      this.params.append("resv", this.g_PayOrder.OrderId);
      this.params.append("hotelcode", this.g_PayOrder.hotelcode);
      this.params.append("cardNo", this.g_UserInfo.Card_no);
      this.resv = this.g_PayOrder.OrderId;
      this.cardNo = this.g_UserInfo.Card_no;
    }
    console.log(this.params);
    //加载数据
    if (typeof window.google != "undefined") {
      this.gmaps = window.google.maps;
      this.loadData();
    } else {
      googleMap().then(google => {
        this.gmaps = google.maps;
        this.loadData();
      });
    }
  },
  created() {
    this.winHeight = Number(window.screen.availHeight);
    this.mapHeight = Number(window.screen.availHeight) + 4;
  },
  methods: {
    //初始化地图
    initMap: function() {
      var _hotelLatLng = new google.maps.LatLng(
        31.202036988392486,
        121.41144881132368
      );
      var mapOptions = {
        zoom: 20,
        center: _hotelLatLng,
        panControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        scrollwheel: true,
        streetViewControl: false,
        mapTypeControl: false,
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.HYBRID,
          google.maps.MapTypeId.SATELLITE,
          google.maps.MapTypeId.TERRAIN,
          "moon"
        ] //定义地图类型
      };
      this.map = new google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );
    },
    //用编号获取房间
    getRoomByNumber: function(number) {
      var find = "";
      this.useableBuilds.forEach((build, index, array) => {
        build.Floors.forEach((floor, index, array) => {
          floor.Rooms.forEach((room, index, array) => {
            if (room.ChamberNumber == number) {
              find = room;
              find.HallID = build.HallID;
              find.FloorID = floor.FloorID;
            }
          });
        });
      });
      return find;
    },
    //初始化数据
    initData: function() {
      this.useableBuilds = this.apiData.Halls;
      //初始化房间特性、楼号、层号
      this.useableBuilds.forEach((build, index, array) => {
        build.roomNum = 0;
        build.Floors.forEach((floor, index, array) => {
          floor.roomNum = 0;
          floor.Rooms.forEach((room, index, array) => {
            build.roomNum++;
            floor.roomNum++;
            room.HallID = build.HallID;
            room.FloorID = floor.FloorID;
            this.setRoomTrait(room);
          });
        });
      });
      this.ActiveRooms = [];
      this.selectedRooms = [];
      this.setSelectedRoom();
      this.setCurrentBuild();
      this.setCurrentFloor();
    },
    //加载酒店数据
    loadData: function() {
      this.$http
        .post(api.getUseableRooms(), this.params.toParam())
        .then(res => {
          if (res.Result) {
            this.apiData = res.Data;
            //this.apiData = mapData.datas
            this.initData();
            this.initMap();
            this.render();
          } else {
            this.hintMsg = res.Message;
            this.showToast();
          }
        });
    },
    //提交选房
    postRoom: function() {
      //校验选中房间
      if (!this.selectedRoomCheck()) {
        this.showToast();
        return;
      }
      var that = this;
      var params = new this.URLSearchParam();
      params.append("chamberNos", this.roomNo);
      params.append("resv", this.resv);
      params.append("cardNo", this.cardNo);
      this.$http.post(api.postRoom(), params.toParam()).then(res => {
        if (res.Result) {
          that.hintMsg = res.Data;
          that.showToast();
          if (that.sign == "") {
            setTimeout(function() {
              that.$router.push({ path: "/order/OrderDetails" });
            }, 1000);
          }
          setTimeout(function() {
            that.$router.go(-1);
          }, 1000);
        } else {
          if (res.Message == "传入的房间号匹配子订单失败") {
            res.Message = "您选择的房间数量和预订的房间数量不匹配";
          }
          if (res.Message == "正在为您提交选房信息，请稍后……") {
            res.Message = "您的选择没有变化";
          }
          that.hintMsg = res.Message;
          that.showToast();
        }
      });
    },
    //渲染
    render: function() {
      var that = this;
      this.addOverlayToFloor(this.currentFloor);
      this.PanToFloor(this.currentFloor);
      this.currentFloor.Rooms.forEach(function(room, index, array) {
        that.addOverlayToRoom(room);
      });
    },
    //设置选中房间
    setSelectedRoom: function() {
      this.apiData.AssignInfos.forEach((item, index, array) => {
        var room = this.getRoomByNumber(item.Room.ChamberNumber);
        this.selectedRooms.push(room);
      });
    },
    //设置房间特性
    setRoomTrait: function(room) {
      var traits = {
        //朝向
        orientation: [],
        //位置
        position: [],
        //设施
        facilities: [],
        //其他
        others: []
      };
      if (room.Hobby != "") {
        room.Hobby.forEach(function(hobby, index, array) {
          switch (hobby) {
            case "窗朝中庭":
            case "窗朝花园":
            case "窗朝马路":
            case "阳光房（窗户朝阳）":
              traits.orientation.push(hobby);
              break;
            case "靠角落":
            case "靠楼梯":
            case "靠电梯":
              traits.position.push(hobby);
              break;
            case "带棋牌桌":
            case "带沙发":
            case "带液晶电视":
              traits.facilities.push(hobby);
              break;
            case "安静房":
            case "景观房":
            case "无烟房":
              traits.others.push(hobby);
              break;
          }
        });
      }

      room.Traits = traits;
    },
    //设置当前显示楼
    setCurrentBuild: function(build) {
      if (build) {
        this.currentBuild = build;
      } else if (this.selectedRooms.length > 0) {
        //从楼栋集合中取得对应的楼栋对象
        var hallId = this.selectedRooms[0].HallID;
        this.useableBuilds.forEach((item, index, array) => {
          if (item.HallID == hallId) {
            this.currentBuild = item;
            return;
          }
        });
      } else {
        //2.未选择房间则以空房间量最多的楼栋
        //保存所有楼栋的最大房间数量
        var maxRoomNum = 0;
        this.useableBuilds.forEach((build, index, array) => {
          var currentRoomNum = 0;
          build.Floors.forEach((floor, index, array) => {
            floor.Rooms.forEach((room, index, array) => {
              currentRoomNum++;
            });
          });
          if (currentRoomNum > maxRoomNum) {
            maxRoomNum = currentRoomNum;
            this.currentBuild = build;
          }
        });
      }
    },
    //设置当前显示层
    setCurrentFloor: function(floor) {
      //清空
      this.currentFloor = null;
      if (floor) {
        this.currentFloor = floor;
      } else if (this.selectedRooms.length > 0) {
        //优先当前建筑中有选中房的楼层
        var floors = this.currentBuild.Floors;
        floors.forEach((floor, index, item) => {
          if (floor.FloorID == this.selectedRooms[0].FloorID) {
            this.currentFloor = floor;
          }
        });
      }
      if (this.currentFloor == null) {
        //2.未选择楼层则使用空房间量最多的楼层
        //保存所有楼层的最大房间数量
        var maxRoomNum = 0;
        this.currentBuild.Floors.forEach((floor, index, array) => {
          var currentRoomNum = 0;
          floor.Rooms.forEach((room, index, array) => {
            currentRoomNum++;
          });
          if (currentRoomNum > maxRoomNum) {
            maxRoomNum = currentRoomNum;
            this.currentFloor = floor;
          }
        });
      }
    },
    //给房间增加覆盖物
    addOverlayToRoom: function(room) {
      var gmaps = this.gmaps;
      room.LatLngArray = [];

      //转化谷歌
      room.LatLngBounds.forEach(function(item, index, array) {
        room.LatLngArray.push(new gmaps.LatLng(item.Lat, item.Lng));
      });
      var color = this.getRoomColor(room);
      room.Polygon = new gmaps.Polygon({
        paths: room.LatLngArray,
        strokeColor: color[1],
        strokeOpacity: 0.8, // 透明度 80%
        strokeWeight: 1, // 宽度 1像素
        fillColor: color[0], // 填充色
        fillOpacity: 0.3, // 填充色透明度
        geodesic: true,
        editable: false,
        chamberObj: room,
        mapManager: this
      });
      //添加点击事件
      gmaps.event.addListener(
        room.Polygon,
        "click",
        handlerFactory(this.roomOverlayClick, room.Polygon)
      );

      //已选房标记
      if (room.IsAssign) {
        var update = {
          fillColor: "#70ac29",
          strokeColor: "#70ad29",
          fillOpacity: 0.8
        };
        room.Polygon.setOptions(update);
      }
      room.Polygon.setMap(this.map);
    },
    //取消房间遮盖物
    clearOverlayToRoom: function(room) {
      room.Polygon.setMap(null);
    },
    //给楼层增加覆盖物
    addOverlayToFloor: function(floor) {
      var gmaps = this.gmaps;

      console.log(floor.LatLngBounds[0].Lat);
      console.log(floor.LatLngBounds[0].Lng);
      console.log(floor.LatLngBounds[1].Lat);
      console.log(floor.LatLngBounds[1].Lng);

      floor.ImageBounds = new gmaps.LatLngBounds(
        new gmaps.LatLng(floor.LatLngBounds[0].Lat, floor.LatLngBounds[0].Lng),
        new gmaps.LatLng(floor.LatLngBounds[1].Lat, floor.LatLngBounds[1].Lng)
      );
      var imagePath =
        this.apiData.ResourceDomain +
        floor.HallID +
        "-" +
        floor.FloorID +
        ".png";
      //var imagePath = "http://10.3.90.3:8015/UploadFiles/OTHER/Ohters/021003/"+floor.HallID + "-" + floor.FloorID + ".png"
      floor.GroundOverlay = new gmaps.GroundOverlay(
        imagePath,
        floor.ImageBounds
      );
      floor.GroundOverlay.setMap(this.map);
    },
    //取消当前楼层遮罩和该楼层的房间遮罩
    clearOverlayToFloor: function() {
      if (typeof this.currentFloor.GroundOverlay != "undefined") {
        this.currentFloor.GroundOverlay.setMap(null);
      }
      this.currentFloor.Rooms.forEach(function(room, index, array) {
        if (typeof room.Polygon != "undefined") {
          room.Polygon.setMap(null);
        }
      });
    },
    //获取房间覆盖物颜色
    getRoomColor: function(room) {
      var isGood = false;
      var skc = "#226DDD",
        fop = "#0066FF",
        badHobbys = [
          "暗",
          "地下室",
          "靠角落",
          "无窗",
          "靠楼梯",
          "靠电梯",
          "吸烟房",
          "靠两端",
          "其他",
          "窗朝马路",
          "窗朝过道",
          "窗朝消防梯"
        ],
        goodHobbys = ["安静房", "阳光房（窗户朝阳）", "靠电梯", "景观房"];
      // 优选房颜色
      if (this.divisionGoodRoom && parseInt(room.FloorID, 10) >= 4) {
        room.Traits.orientation.forEach(function(trait, index, array) {
          if (trait == "阳光房（窗户朝阳）") {
            isGood = true;
            return;
          }
        });
        room.Traits.position.forEach(function(trait, index, array) {
          if (trait != "靠楼梯" && trait != "靠两端" && trait == "靠电梯") {
            isGood = true;
            return;
          }
        });
        room.Traits.others.forEach(function(trait, index, array) {
          if (trait == "景观房" || trait == "安静房") {
            isGood = true;
            return;
          }
        });
      }
      if (isGood) {
        skc = "#F6DC03";
        fop = "#FEFEF4";
      }
      return [skc, fop];
    },
    //定位到某个楼层
    PanToFloor: function(floor) {
      this.map.panTo(floor.ImageBounds.getCenter());
    },
    //定位到某个房间
    PanToRoom: function(room) {
      this.map.panTo(room.LatLngArray[0]);
    },
    //选中楼层点击事件
    chooseFloorClick: function(floorIndex) {
      this.clearOverlayToFloor();
      this.setCurrentFloor(this.currentBuild.Floors[floorIndex]);
      this.render();
    },
    //选中建筑点击事件
    chooseBuildClick: function(buildIndex) {
      this.clearOverlayToFloor();
      this.setCurrentBuild(this.useableBuilds[buildIndex]);
      this.setCurrentFloor();
      this.render();
    },
    //取消房间事件
    cancelRoomClick: function(roomIndex) {
      var ob = this.getRoomByNumber(
        this.selectedRooms[roomIndex].ChamberNumber
      );
      this.selectedRooms.splice(roomIndex, 1);
      //修改选中状态
      ob.IsAssign = false;
      //如果要取消的房间正在展示，重新渲染
      if (ob.FloorID == this.currentFloor.FloorID) {
        this.clearOverlayToRoom(ob);
        this.addOverlayToRoom(ob);
      }
      //关闭显示的房间特性
      this.closeRoomTraits();
    },
    //设置展示房
    setDisplayRoom: function(roomIndex) {
      this.displayRoom = this.selectedRooms[roomIndex];
      this.openRoomTraits();
    },
    //房间特性淡入
    openRoomTraits: function() {
      this.showRoomTraits = true;
      if (this.traitsTimer) clearTimeout(this.traitsTimer);
      this.traitsTimer = setTimeout(() => {
        this.showRoomTraits = false;
      }, 4000);
    },
    //房间特性淡出
    closeRoomTraits: function() {
      this.showRoomTraits = false;
      if (this.traitsTimer) clearTimeout(this.traitsTimer);
    },
    //房间覆盖物点击事件
    roomOverlayClick: function(polygon) {
      //设置当前选中状态(取反)
      var isAssign = (polygon.chamberObj.IsAssign = !polygon.chamberObj
        .IsAssign);
      if (isAssign == true) {
        try {
          //this.mapManager.UI_AssignRoom.AddAssignRoom(this.chamberObj);
          //增加已选中房列表
          this.selectedRooms.push(polygon.chamberObj);
          //设置该房为展示房
          this.displayRoom = polygon.chamberObj;
          //展示房间特性
          this.openRoomTraits();
          var update = {
            fillColor: "#70ac29",
            strokeColor: "#70ad29",
            fillOpacity: 0.8
          };
          polygon.setOptions(update);
        } catch (errMsg) {
          if (errMsg == "overflow") {
            alert("不能超量选择，如需更换选房，请先取消1间已选房间");
          }
          room.chamberObj.IsAssign = false;
        }
      } else {
        polygon.chamberObj.IsAssign = true;
      }
    },
    //打开提示窗
    showToast: function() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 3000);
    },
    //隐藏提示窗
    hideToast: function() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    //校验选中的房间
    selectedRoomCheck: function() {
      //1.未选中房间
      if (this.selectedRooms == "" || this.selectedRooms.length == 0) {
        this.hintMsg = "请选择房间";
        return false;
      }
      //2.选中的房间数量发生变化
      else if (this.selectedRooms.length != this.apiData.AssignInfos.length) {
        return true;
      }
      //3.选中的房间发生变化
      else {
        var that = this;
        var result = false;
        this.apiData.AssignInfos.forEach(function(assign, index, array) {
          that.selectedRooms.forEach(function(room, index, array) {
            //某个选中的房间在原来的选中房间中不存在
            if (assign.Room.ChamberNumber != room.ChamberNumber) {
              result = true;
            }
          });
        });
        if (!result) {
          this.hintMsg = "不能选择和原来一样的房间";
        }
        return result;
      }
      //4.选中房间总数是否等于预订的房间总数
    },
    // 后退一页
    goback: function() {
      javascript: history.go(-1);
    }
  },
  computed: {
    ...mapGetters(["g_UserInfo", "g_PayOrder"]),
    buildHeight() {
      if (this.useableBuilds != "")
        return Number(this.useableBuilds.length) * 48 + 10 + "px";
    },
    //选中房间号用逗号拼接
    roomNo() {
      var roomNo = "";
      this.selectedRooms.forEach(function(room, index, array) {
        if (index != 0) {
          roomNo += ",";
        }
        roomNo += room.ChamberNumber;
      });
      return roomNo;
    }
  }
};
function handlerFactory(exFunc, param) {
  return function() {
    exFunc(param);
  };
}
</script>



// WEBPACK FOOTER //
// selectRoomByMap.vue?55f08a42